import { useContext } from "react"
import { ThreadsContext } from "../context/threads"

export function useThreadsContext() {
  return useContext(ThreadsContext)
}
